import { ServerSideBlock } from '../';
import { ServerSideRender, SelectControl } from '../components';

export default class ChoosePost extends ServerSideBlock {
  static attributes() {
    return {
      post_id: SelectControl,
    };
  }

  render() {
    return (
      <div>
        <SelectControl
          attr="post_id"
          context={this.state}
          options={this.state.posts}
        />

        <ServerSideRender
          context={this.state}
          attributes={
            this.attr('post_id') ? { post_id: this.attr('post_id') } : {}
          }
        />
      </div>
    );
  }

  componentDidMount() {
    // Get posts
    let collection = new wp.api.collections.Posts();

    collection.fetch().done(posts => {
      // Format options
      let options = posts.map(post => {
        return {
          value: post.id,
          label: post.title.rendered,
        };
      });

      // Empty
      options.unshift({
        value: '',
        label: 'Choose one post',
      })

      // Update state
      this.setState({ posts: options });
    });
  }
}
